<ng-template #spinner>
  <div class="spinner">
    <mat-spinner class="m-auto" diameter="60"></mat-spinner>
  </div>
</ng-template>

<section class="title-row">
  <h2
    class="typography-sub-heading"
    [translate]="'PhoneNumberFormComponent:EditPhoneNumberTitle'"
    *ngIf="!newPhoneNumber"
  >
    Edit phone number
  </h2>
  <h2
    class="typography-sub-heading"
    [translate]="'PhoneNumberFormComponent:AddPhoneNumberTitle'"
    *ngIf="newPhoneNumber"
  >
    Add phone number
  </h2>
</section>

<ng-container *ngIf="(countries$ | async)?.length; else spinner">
  <form
    autocomplete="off"
    class="push-md-1 phone-number-input-form"
    novalidate
    [formGroup]="phoneNumberForm"
    (keydown.enter)="$event.preventDefault()"
  >
    <!-- contact type -->
    <mat-form-field class="form-input__container">
      <mat-select [placeholder]="'PhoneNumberFormComponent:AddressTypeLabel' | translate" formControlName="type">
        <mat-option [value]="'home'"><span [translate]="'PhoneNumberFormComponent:Home'">Home</span></mat-option>
        <mat-option [value]="'mobile'"><span [translate]="'PhoneNumberFormComponent:Mobile'">Mobile</span></mat-option>
        <mat-option [value]="'work'"><span [translate]="'PhoneNumberFormComponent:Work'">Work</span></mat-option>
        <mat-option [value]="'other'"><span [translate]="'PhoneNumberFormComponent:Other'">Other</span></mat-option>
      </mat-select>
      <mat-error
        [translate]="'PhoneNumberFormComponent:PhoneNumberTypeErrorMsg'"
        ngxErrors="type"
        ngxError="required"
        when="touched"
        role="alert"
      >
        Please select a Type
      </mat-error>
    </mat-form-field>

    <!-- phone number -->
    <mat-form-field class="form-input__container">
      <mat-select
        panelClass="country-code-overlay"
        [placeholder]="
          (customVariables$ | async)?.country_calling_code || 'PhoneNumberFormComponent:CountryCallingCode' | translate
        "
        formControlName="country"
        (selectionChange)="selectCountryCallingCode($event)"
      >
        <mat-select-trigger>
          <span class="chosen-country" [class.hidden]="!selectedCountry">
            <span>{{ selectedCountry?.name }} </span>
            <span class="chosen-country__code"> (+{{ selectedCountry?.calling_code }})&nbsp;</span>
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let country of countries$ | async" [value]="country">
          <span class="country-option">
            <span>{{ country?.name }}</span>
            <span class="country-option__code">(+{{ country?.calling_code }})&nbsp;</span>
          </span>
        </mat-option>
      </mat-select>
      <mat-error
        [translate]="
          (customVariables$ | async).country_calling_code_error || 'PhoneNumberFormComponent:SelectCountryCodeErrorMsg'
        "
        ngxErrors="country"
        ngxError="required"
        when="touched"
        role="alert"
      >
        Please select a country code
      </mat-error>
    </mat-form-field>
    <mat-form-field
      class="form-input__container phone-number"
      [ngClass]="{ 'phone-number--with-code': !selectedCountry?.calling_code }"
    >
      <span
        *ngIf="selectedCountry?.calling_code"
        matPrefix
        [class.hidden]="!selectedCountry"
        class="typography-body-book"
        dir="ltr"
        >+{{ selectedCountry?.calling_code }}&nbsp;</span
      >
      <input
        class="phone-number-input"
        autocomplete="off"
        name="whatever"
        matInput
        formControlName="number"
        type="tel"
        [placeholder]="'PhoneNumberFormComponent:PhoneNumberPlaceholder' | translate"
      />

      <mat-error
        [translate]="'PhoneNumberFormComponent:ValidPhoneNumberErrorMsg'"
        ngxErrors="number"
        ngxError="required"
        when="touched"
        role="alert"
      >
        Please enter a valid phone number
      </mat-error>
      <mat-error
        [translate]="'PhoneNumberFormComponent:ValidPhoneNumberErrorMsg'"
        ngxErrors="number"
        ngxError="pattern"
        when="touched"
        role="alert"
      >
        Please enter a valid phone number
      </mat-error>
    </mat-form-field>

    <!-- preferred -->
    <div class="row">
      <div class="col-xs-12 col-md-12 pb-1">
        <div *ngIf="(phone_number$ | async)?.preferred; else el_form_not_preferred">
          <ng-container>{{ 'PhoneNumberFormComponent:PreferredNumberLabel' | translate }}</ng-container>
        </div>

        <ng-template #el_form_not_preferred>
          <mat-checkbox formControlName="preferred">
            <ng-container>{{ 'PhoneNumberFormComponent:PreferredNumberCheckboxLabel' | translate }}</ng-container>
          </mat-checkbox>
        </ng-template>
      </div>
    </div>
  </form>
</ng-container>

<section class="submit-row top-separator">
  <button
    id="delete-current-record"
    *ngIf="!newPhoneNumber && !(phone_number$ | async)?.preferred"
    aria-label="close"
    (click)="removePhoneNumber()"
    mat-raised-button
    class="mr-2 remove-button"
  >
    {{ 'ProfileDetails:Delete' | translate }}
  </button>
  <div
    class="action-buttons"
    [ngClass]="{ 'action-buttons--has-seperator': !newPhoneNumber && !(phone_number$ | async)?.preferred }"
  >
    <button
      id="cancel-current-phone-number-edit"
      aria-label="close"
      (click)="closeForm()"
      mat-raised-button
      class="close-button"
    >
      {{ 'PopupForm:Close' | translate }}
    </button>
    <button
      id="save-current-phone-number-edit"
      aria-label="submit"
      (click)="submitForm()"
      mat-raised-button
      color="primary"
      [disabled]="!(countries$ | async)?.length"
    >
      {{ 'PopupForm:Submit' | translate }}
    </button>
  </div>
</section>
